import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import styleData from "./Notification.module.css";
import MainContent from "../../../layouts/maincontent/MainContent";
import {
  getNotificationDetailes,
  markAsReadNotification,
} from "../../../adapters/apis/notifications/notifications";

const NotificationDetails = () => {
  const { id } = useParams();
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id) return;
    setLoading(true);

    getNotificationDetailes(id)
        .then((res) => {
          setNotification(res.data.data);

          // لو مش مقروء ابعت mark as read
          if (!res.data.data.is_read) {
            markAsReadNotification(id).catch((err) =>
                console.error("markAsRead failed", err)
            );
          }
        })
        .catch((err) => console.error("Failed to fetch notification", err))
        .finally(() => setLoading(false));
  }, [id]);

  return (
      <MainContent>
        <section className="container">
          <div className="d-flex align-items-center flex-wrap mb-5">
            <Link className={`${styleData["btn-arrow"]} ms-3`} to={-1}>
              <i className="fa-solid fa-arrow-right mt-1"></i>
            </Link>
            <h3 className="mb-0 ms-2 fw-bold" style={{ color: "#005DA8" }}>
              تفاصيل الإشعار
            </h3>
          </div>

          {loading ? (
              <div className="text-center py-5" style={{ color: "#005DA8" }}>
                <div className="spinner-border" role="status" />
              </div>
          ) : (
              <div
                  dir="rtl"
                  className="px-2 px-sm-3 py-5 rounded bg-white"
                  style={{
                    maxHeight: "70vh",
                    overflowY: "auto",
                    boxShadow: "0px 3px 6px #00000029",
                  }}
              >
                <div className="d-flex flex-column flex-sm-row justify-content-start gap-3 gap-sm-4">
                  {/* Title + Message */}
                  <div className="flex-grow-1 d-flex flex-column align-items-start px-2 px-sm-4">
                    <h5 className="fw-semibold mb-4" style={{ color: "#0095FF" }}>
                      {notification?.title_ar}
                    </h5>
                    <p className="mb-0" style={{ color: "#0D3E69", textAlign: "right" }}>
                      {notification?.message_ar}
                    </p>
                    {notification?.link && (
                      <a href={notification?.link} className="mt-3" style={{ color: "#0095FF" }}>
                        اضغط هنا 
                      </a>
                    )}
                  </div>

                  {/* Date + Time */}
                  <div style={{ minWidth: 110, color: "#0D3E69" }}>
                    <div>{notification?.date}</div>
                    <div>{notification?.time}</div>
                  </div>
                </div>
              </div>
          )}
        </section>
      </MainContent>
  );
};

export default NotificationDetails;